const isString = (_) => {
    return Object.prototype.toString.call(_) === "[object String]";
};
export { isString };
